import { render, staticRenderFns } from "./IconPayDetail.vue?vue&type=template&id=748155bc&"
import script from "./IconPayDetail.vue?vue&type=script&lang=js&"
export * from "./IconPayDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports